import React from 'react'
import { FieldProps, YesOrNoOrNegotiableString } from '../../../../../../../@types/types'
import { OtherFacilitiesScreenValidationResult } from '../../../../../../../@types/validation-types'
import ChipOptionField from '../../../../../../common/inputs/chipOptionField/ChipOptionField'
import { useTranslation } from 'react-i18next'
import { IconS24InfoCircle24 } from '@is24/cosma-ui-icons'
import { Tooltip } from 'is24-corecss'
import LabelWithTooltip from '../../../basicInfo/fields/common/LabelWithTooltip'
import './PetsAllowed.css'
import PopoverContent from '../../../objectDetails/fields/common/PopoverContent'

export interface PetsAllowedProps extends FieldProps<OtherFacilitiesScreenValidationResult> {
  showTooltip?: boolean
  showPopoverTooltip?: boolean
}

function LabelWithRegularTooltip() {
  const { t } = useTranslation()

  return (
    <div className='display-flex gap-s' style={{ alignItems: 'center' }}>
      {t('wizard.screen.otherFacilities.petsAllowed')}
      <Tooltip.Root placement='right'>
        <Tooltip.Target>
          <IconS24InfoCircle24 className={'info-icon'} />
        </Tooltip.Target>
        <Tooltip.Content style={{ width: 250 }} className='font-body-medium-regular'>
          {t('wizard.screen.otherFacilities.petsAllowedTooltipText')}
        </Tooltip.Content>
      </Tooltip.Root>
    </div>
  )
}

const PetsAllowed: React.FC<PetsAllowedProps> = ({
  insertionData,
  screenName,
  wrapperClassName = 'grid-item one-whole',
  onChange,
  showTooltip = true,
  showPopoverTooltip = false,
}) => {
  const { t } = useTranslation()

  const labelText = t('wizard.screen.otherFacilities.petsAllowed')
  const label = showPopoverTooltip ? (
    <LabelWithTooltip
      inputId='pets-allowed'
      labelText={labelText}
      tooltipContent={<PopoverContent translationKey='wizard.screen.otherFacilities.petsAllowedTooltipText' />}
      showMandatory={false}
      placement='top'
    />
  ) : showTooltip ? (
    <LabelWithRegularTooltip />
  ) : (
    labelText
  )

  return (
    <div className={wrapperClassName}>
      <ChipOptionField
        id='pets-allowed'
        propertyName='petsAllowed'
        translation='wizard.screen.otherFacilities.'
        labelNode={label}
        option={insertionData.petsAllowed}
        options={YesOrNoOrNegotiableString}
        onChange={(value) => onChange({ screen: screenName, property: 'petsAllowed' }, value)}
      />
    </div>
  )
}

export default PetsAllowed
